module.exports = "lui-button-group{display:-ms-flexbox;display:flex;-ms-flex-align:start;align-items:start}lui-button-group>:not(:first-child){margin-left:var(--lui-padding)}@media (max-width:500px){lui-button-group{-ms-flex-align:stretch;align-items:stretch;-ms-flex-direction:column-reverse;flex-direction:column-reverse}lui-button-group>:not(:first-child){margin:0 0 var(--lui-padding)}}"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-button/theme/lui-button-group.global.scss
// module id = 183
// module chunks = 0 1 18